import React from 'react';

import { cx } from '@emotion/css';

import styles from './PrivacyPolicy.module.scss';
import { PrivacyPolicyView } from './PrivacyPolicyView';

export const PrivacyPolicy = () => {
  return (
    <div className={styles.body}>
      <div className={cx(styles.root, styles.root_form)}>
        <section className={cx(styles.sec, styles.form_wrpr)}>
          <div className={cx(styles.container, styles.inner)}>
            <div className={styles.row}>
              <div className={cx(styles.heading_blk)}>
                <PrivacyPolicyView styles={styles} />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
